import * as React from 'react';
import * as Fuse from 'fuse.js';
import { Button, Card, Form, Notification, Tooltip } from '../';
import fields from '../../data/fields';
import search from '../../data/search';

interface Props {
  accounts: Array<any>;
  handleDefault: (id: number) => void;
  handleDelete: (id: number) => void;
}

interface State {
  accounts: Array<any>;
}

class AccountList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      accounts: this.props.accounts,
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  /**
   * When new props are received check if the accounts state
   * needs to be updated.
   */
  componentWillReceiveProps(newProps: Props) {
    if (this.props.accounts !== newProps.accounts) {
      this.setState({ accounts: newProps.accounts });
    }
  }

  /**
   * Use fuse to fuzzy search for account in account list
   */
  handleSearch(data) {
    if (data.search) {
      const fuse = new Fuse(this.props.accounts, search.accounts);
      this.setState({ accounts: fuse.search(data.search) });
    } else {
      this.setState({ accounts: this.props.accounts });
    }
  }

  render() {
    return (
      <div>
        <Card list>
          <Form
            type="search"
            handleChange={this.handleSearch}
            hasButton={false}
            fields={fields.accounts.search}
          />
        </Card>
        {this.state.accounts.length === 0 && (
          <Card list>
            <Notification type="default">No sites assigned</Notification>
          </Card>
        )}
        {this.state.accounts.map((item) => {
          return (
            <Card list key={item.id}>
              <div className="level">
                <div className="level-left">
                  <strong>{item.name}</strong>
                </div>
                <div className="level-right">
                  <div className="level-item">
                    <Button
                      className={`is-${
                        item.user_account.is_default ? 'primary' : 'default'
                      }`}
                      handleClick={() => {
                        this.props.handleDefault(item.id);
                      }}
                    >
                      Default
                    </Button>
                  </div>
                  {this.props.handleDelete && (
                    <div className="level-item">
                      <Tooltip text="Remove this site">
                        <div
                          className="delete "
                          onClick={() => {
                            this.props.handleDelete(item.id);
                          }}
                        />
                      </Tooltip>
                    </div>
                  )}
                </div>
              </div>
            </Card>
          );
        })}
        {this.state.accounts.length > 0 &&
          this.state.accounts.length === 0 && (
            <Card list>
              <Notification type="default">
                No relevant sites assigned
              </Notification>
            </Card>
          )}
      </div>
    );
  }
}

export default AccountList;
